/* eslint-disable import/prefer-default-export */
import { formatMetaDate } from "../../../utils/formateDate";
import getInitialsFromText from "../../../utils/getInitialsFromText";

export const transformApiResponse = (apiData) => apiData.map((entry) => ({
  id: entry.id,
  icon: getInitialsFromText(entry.noteRevisionBy),
  case: entry.caseID,
  meta: formatMetaDate(entry.noteRevisionDate),
  text: `Assigned to <strong>${entry.noteRevisionBy}</strong>`,
  badge: entry.noteType,
  links: [
    { label: "Ask Application Status Agent", href: "" },
  ],
}));
